import { render, staticRenderFns } from "./AdsDetail.vue?vue&type=template&id=4de83bd6&scoped=true&"
import script from "./AdsDetail.vue?vue&type=script&lang=ts&"
export * from "./AdsDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AdsDetail.vue?vue&type=style&index=0&id=4de83bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de83bd6",
  null
  
)

export default component.exports